export const HEADERS_PROPERTY_TABLE = [
  { text: "Status Venta", value: "contract_status", width: "120px" },
  { text: "Status Renta", value: "rent_status", width: "120px" },
  { text: "ID", width: "100", value: "code" },
  { text: "Desarrollo", value: "real_estate_development.name" },
  { text: "Precio", value: "pricing.price" },
  { text: "Precio", value: "rental_pricing.monthly_rent" },
  { text: "#Recs.", value: "features.rooms" },
  { text: "#Baños", value: "features.bathrooms" },
  { text: "Planta", value: "floor.name", width: "120px" },
  { text: "Modelo", value: "tower.name" },
  { text: "Flex", value: "flex" },
  { text: "TDP", value: "building.type" },
  { text: "M2", value: "building.total" },
  { text: "Precio x M2", value: "pricePerSquareMeter", sortable: false }
];

export const CONTRACT_TYPE = {
  sale: "sale",
  rent: "rent",
  both: "both"
};

export const RENT_STATUS = ["indefinido", "disponible", "rentado", "reservado"];
export const CONTRACT_STATUS = [
  "indefinido",
  "disponible",
  "vendido",
  "reservado"
];
